import {
  IAssignmentChangesDto,
  IDocumentDto,
  INotesQueryDependencies,
  IProductChangesDto,
  IProductDto,
  IProductForm,
} from '@common/features/submission/types';
import { Id, SubmissionTaskType } from '@common/types';
import { SubmissionTaskStatuses } from '@common/services/types';
import Tabs from '@components/Tabs/Tabs';
import { useState } from 'react';
import * as Styled from '../../styles';
import { NotesTab } from './Tabs/NotesTab';
import { ProductsTab } from './Tabs/ProductsTab';
import { FileRoles } from '@common/features/document/types';

interface Props {
  showLookupValidation?: boolean;
  isLoading: boolean;
  products: IProductDto[];
  documents: IDocumentDto[];
  submissionTaskId: string;
  submissionTaskType: SubmissionTaskType;
  taskStatus?: SubmissionTaskStatuses;
  unapprovedProductForms?: IProductForm[];
  productsChanges?: IProductChangesDto[];
  upcomingProductChanges?: IProductChangesDto[];
  removeButtonText?: string;
  notesQueryDependencies?: INotesQueryDependencies;
  isReadonly?: boolean;
  showDocumentCountChanges: boolean;
  assignments: IAssignmentChangesDto[];
  showAttachmentsColumn: boolean;
  isTvtFeatureEnabled?: boolean;
  onEditXml?: () => void;
  onUpdateClick?: (productId: Id) => void;
  onRemoveClick?: (productId: Id) => void;
  onDetailsClick?: (productId: Id) => void;
  onFileDownload?: (noteId: number, fileRole?: FileRoles) => void;
  onFormManageClick?: (formId: string) => void;
}

export const DetailsTabs = ({
  showLookupValidation = false,
  isLoading,
  removeButtonText,
  products,
  documents,
  submissionTaskId,
  submissionTaskType,
  taskStatus,
  unapprovedProductForms,
  productsChanges,
  upcomingProductChanges,
  notesQueryDependencies,
  isReadonly,
  showDocumentCountChanges,
  assignments,
  showAttachmentsColumn,
  isTvtFeatureEnabled,
  onEditXml,
  onUpdateClick,
  onRemoveClick,
  onDetailsClick,
  onFileDownload,
  onFormManageClick,
}: Props) => {
  const [selectedTab, setSelectedTab] = useState<string>('Products');

  const handleTabSelected = (label: string) => {
    setSelectedTab(label);
  };

  const items = [
    {
      label: 'Products',
      content: (
        <ProductsTab
          showLookupValidation={showLookupValidation}
          isLoading={isLoading}
          removeButtonText={removeButtonText}
          products={products}
          unapprovedProductForms={unapprovedProductForms}
          documents={documents}
          isReadonly={isReadonly}
          onEditXml={onEditXml}
          onUpdateClick={onUpdateClick}
          onRemoveClick={onRemoveClick}
          onDetailsClick={onDetailsClick}
          onFormManageClick={onFormManageClick}
          assignments={assignments}
          showDocumentCountChanges={showDocumentCountChanges}
          productsChanges={productsChanges}
          upcomingProductChanges={upcomingProductChanges}
          submissionTaskType={submissionTaskType}
          taskStatus={taskStatus}
        />
      ),
    },
    {
      label: 'Notes',
      content: (
        <NotesTab
          submissionTaskId={submissionTaskId}
          notesQueryDependencies={notesQueryDependencies}
          onFileDownload={onFileDownload}
          showAttachmentsColumn={showAttachmentsColumn}
          isTvtFeatureEnabled={isTvtFeatureEnabled}
        />
      ),
    },
  ];

  return (
    <Styled.SubmissionTaskDetailsUnitWrapper style={{ padding: '15px 0px 5px 0px' }}>
      <Tabs items={items} selectedTab={selectedTab} onTabSelected={handleTabSelected} />
    </Styled.SubmissionTaskDetailsUnitWrapper>
  );
};
